import React from "react";
import "./style.css";
import ErrorImage from "../../assets/img/403.png";
import { Button } from "antd";
import signOut from "helpers/signOut";

const Error403 = () => {
  return (
    <div className="error-container">
      <div className="error-content">
        <img src={ErrorImage} alt="Not Found" width="250" height="250" />
        <p className="error-header">Oops!</p>
        <p className="error-type">403 - FORBIDDEN</p>
        <p className="error-desc">
          Mohon maaf, anda tidak memiliki akses ke halaman yang anda muat.
        </p>
        <Button type="primary" size="large" onClick={() => signOut("")}>
          LOGOUT
        </Button>
      </div>
    </div>
  );
};

export default Error403;
